import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { FooterSocialMedia } from '@hotelplan/components.common.footer';
import { IconMenuItem } from '@hotelplan/graphql.types';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { ToolsWrap, ShareSiteTool } from 'components/domain/sitetools';

const FooterSocialMediaWrap = styled(FooterSocialMedia)(
  sx2CssThemeFn(({ theme: { colors } }) => ({
    border: 'none',
    mb: ['10px', 0],
    '.social-media-icon': {
      width: ['16px', '18px'],
      height: ['16px', '18px'],
      margin: 'auto',
      zIndex: 2,
    },
    '& a': {
      width: ['30px', '50px'],
      height: ['30px', '40px'],
      background: [
        colors.grayMiddle,
        'linear-gradient(to bottom,#fff 0,#eee 100%)',
      ],
      display: 'flex',
      borderRadius: ['50%', '0px'],
      mx: [3, 0],
      '&:first-child': {
        borderRadius: ['50%', '0px'],
      },
      '&:not(:last-child)': {
        mr: [null, 0],
        borderRight: [null, '1px solid #ccc'],
      },
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '5px',
        left: '10px',
        width: '30px',
        height: '30px',
        backgroundColor: '#a1a1a1',
        display: ['none', 'block'],
        zIndex: 1,
        borderRadius: '50%',
      },
      '&:hover': {
        background: [null, 'linear-gradient(to bottom,#fff 0,#ccc 100%)'],
      },
    },
    '& a:hover:after': {
      backgroundColor: 'secondary',
    },
  }))
);

interface IFooterSiteToolsProps {
  socials: Array<IconMenuItem>;
}

export default function FooterSiteTools({
  socials,
  children,
}: PropsWithChildren<IFooterSiteToolsProps>): React.ReactElement {
  return (
    <ToolsWrap>
      {children}
      <FooterSocialMediaWrap items={socials} />
      <ShareSiteTool />
    </ToolsWrap>
  );
}
